export default "__VITE_ASSET__DxHU3EDH__"